module.exports = __webpack_public_path__ + "img/Trash-disabled.bd6770f4.svg";